import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { Control, Option, Options, Select } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { isRestrictedFeatureSelector } from 'features/billing';
import { PanelContentContainer } from '../styles';
import { EXTERNAL, INTERNAL } from './constants';
import { getOptionNames } from './helpers';
const optionWrapperCss = "ot2behz";
const OptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionWrapperCss, props.className)} />;
});
export const ConfirmationPageTypeField = () => {
  const isUpgradeRequired = useSelector(state => isRestrictedFeatureSelector(state, {
    featureKey: 'invitee_redirect'
  }));
  const enforceUpgrade = useEnforceUpgrade('invitee_redirect');
  const [{
    value
  }, _, {
    setValue
  }] = useFormField({
    name: 'confirmationPageType'
  });
  const [selectedValue, setSelectedValue] = useState(value);
  const handleChangeSelect = selected => {
    if (selected === INTERNAL) {
      setValue(INTERNAL);
    } else {
      enforceUpgrade(() => {
        setValue(EXTERNAL);
      });
    }
    setSelectedValue(selected);
  };
  const optionNames = getOptionNames();
  return <PanelContentContainer section>
      <label id="confirmation-page-type-label" htmlFor="confirmation-page-type-input">
        <BodyText inline>
          {I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.after_booking')}
        </BodyText>
      </label>
      <Select id="confirmation-page-type-input" value={selectedValue} onChange={handleChangeSelect}>
        <Control aria-labelledby="confirmation-page-type-label">
          {optionNames[selectedValue]}
        </Control>
        <Options>
          <Option value={INTERNAL} selected={selectedValue === INTERNAL}>
            {optionNames[INTERNAL]}
          </Option>
          <Option value={EXTERNAL} selected={selectedValue === EXTERNAL}>
            <OptionWrapper>
              {optionNames[EXTERNAL]}
              {isUpgradeRequired && <Badge>
                  {I18n.t('publisher.event_type_editor.sections.booking_page_options.pro')}
                </Badge>}
            </OptionWrapper>
          </Option>
        </Options>
      </Select>
    </PanelContentContainer>;
};

require("./confirmation_page_type_field.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./confirmation_page_type_field.js");